import { createRoot } from 'react-dom/client';
import { App } from './App';
import 'primeicons/primeicons.css';
import './styles/globals.css';

// Initialize i18n before rendering
import './i18n/config';

createRoot(document.getElementById('root')!).render(<App />);
